<div class="reporting-transactions-fees">
  <ul class="reporting-transactions-fees-tabs">
    <div>
      <li class="nav-item active">
        <a>
          {{ (currentAccount.kind === '3a' ? 'performance.tabs.deposits.title' : 'performance.tabs.transactions') | translate }}
        </a>
      </li>
    </div>
  </ul>
  <div class="white-box" *ngIf="loading; else showTransactions">
    <div class="loading"></div>
  </div>
  <ng-template #showTransactions>
    <div *ngIf="currentAccount.kind === '3a'">
      <app-reporting-deposits
        [currency]="currentAccount.currency"
        [contribution]="currentAccount.max_contribution_level"
        [totalInvestment]="endValues?.total_investment"
        [language]="customer.language"
        [depositThisYear]="currentAccount.deposit_this_year"
      ></app-reporting-deposits>
    </div>
    <div class="reporting-transactions-fees-table">
      <app-deposit-delay-info> </app-deposit-delay-info>
      <div>
        <app-reporting-data-table
          [data]="data"
          [sliceItem]="5"
          [customer]="customer"
          [currency]="currentAccount.currency"
        ></app-reporting-data-table>
        <div class="show-more">
          <div class="show-more-note">
            <span *ngIf="showMoneyPromotionNote || laterReimbursement" class="icon-i-info"></span>
            <p>
              <span *ngIf="showMoneyPromotionNote">{{ 'performance_fees.info.reimbursement_note' | translate }}</span>
              <span *ngIf="laterReimbursement">{{ 'performance_fees.info.reimbursement_note_3a' | translate }}</span>
            </p>
          </div>
          <a routerLink="/reports/transactions" *ngIf="data.length > 5" (click)="track('[Button] Reporting - Show all trasactions')">
            {{ 'performance.tabs.show_more.transactions' | translate }}
          </a>
        </div>
      </div>
    </div>
  </ng-template>
</div>
